import React from 'react';

export default {
	hun: {
		title: 'Személysérüléses közúti közlekedési balesetek 2015\u20132018',
		infoText: "&copy; <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a> közreműködők; MapCruzin.com",
		datasource: 'Adatforrás: Országos Rendőr-Főkapitányság',
		resetMap: 'Térkép alaphelyzetbe',

		severity: {
			2: 'Halálos',
			4: 'Súlyos',
			8: 'Könnyű'
		},

		filtersGroupNames: {
			years: 'Évek',
			layer: 'Rétegek',
			outcome: 'Személysérülés kimenetele',
			alcoholFilterTitle: 'Ittasan okozott balesetek',
			vehicle: 'Okozó'
		},

		alcohol: {
			2: '1',
			4: '2',
			8: '3',
			16: '4',
			32: '5'
		},

		layers: {
			hungary: 'Magyarország',
			points: 'pontok',
			stick: 'hőtérkép',
			map: 'térkép',
			sticksHeight: 'magasság',
			radius: 'átmérő'
		},

		searchbox: {
			settlement: 'Útszám',
			searchButtonText: 'keresés',
			allButtonText: 'összes',
			clerText: 'Keresés törlése'
		},

		vehicleToolTip: {
			0: 'motorkerékpár',
			1: 'személygépkocsi',
			2: 'autóbusz',
			3: 'tehergépkocsi',
			4: 'kerékpár',
			5: 'segédmotoros-kerékpár',
			6: 'gyalogos',
			7: 'egyéb jármű'
		},

		toolTip: {
			0: 'Dátum',
			1: 'Útszám',
			2: 'Település',
			3: 'Kimenetel',
			4: 'Okozó'
		},

		filterReset: 'Szűrők törlése',

		accident: 'baleset',
		
		miniText: {
			sun: 'Váltás napi bontásra',
			map: 'Váltás térképes nézetre'
		},

		mapHelp: {
			left: `Egér görgő: nagyít/kicsinyít.`,
			right: `Egér bal gomb: mozgat.`,
			center: `Egér jobb gomb: forgat.`,
			},

		methodology: 'Módszertan',

		close: 'Bezár',
		infoTitle: <h3>MÓDSZERTANI MEGJEGYZÉSEK</h3>,
		info: <div>
<p><b>Közlekedési baleset</b> fogalmán &ndash; statisztikai szempontból &ndash; olyan váratlan, nem szándékosan előidézett forgalmi eseményt értünk, amelynek következményeként haláleset, illetve személysérülés történt, vagy anyagi kár keletkezett.</p>
<p><b>Személysérüléses közúti közlekedési baleset:</b> minden olyan közúton vagy a közforgalom számára megnyitott magánúton történt baleset, amelyben legalább egy mozgó jármű részt vett, és amelynek következtében legalább egy személy meghalt, vagy megsérült.</p>
<ol>
<li>A balesetek minősítése kimenetel szerint:
	<ol type="a">
		<li><b>halálos kimenetelű</b> az a <b>baleset</b>, amelynél legalább egy személy a baleset helyszínén, illetve 30 napon belül meghal;</li>
		<li><b>súlyos sérüléses</b> az a <b>baleset</b>, amelynél legalább egy személy súlyosan, 8 napon túl gyógyulóan megsérült, de haláleset nem történt;</li>
		<li><b>könnyű sérüléses</b> az a <b>baleset</b>, amelynél legalább egy személy könnyen, 8 napon belül gyógyulóan megsérült, de haláleset és súlyos sérülés nem történt.</li>
	</ol>
</li>
<li>A személysérülések minősítése:
<ol type="a">
		<li><b>halálos sérülés:</b> olyan súlyos sérülés, amelyet valaki baleset során szenved el, vagy annak következtében a balesetet követő 30 napon belül elhalálozik;</li>
		<li><b>súlyos sérülés:</b> olyan sérülés, amelyet valaki baleset során szenved el, és amely
			<ul>
				<li>a sérüléstől számított hét napon belül 48 órát meghaladó kórházi ápolást tesz szükségessé, vagy</li>
				<li>csonttörést okoz, kivéve az ujj-, lábujj- és orrtörést, vagy</li>
				<li>olyan vágott sebekkel jár, amelyek súlyos vérzést vagy ideg-, izom-, illetve ínsérülést okoznak, vagy</li>
				<li>belső szervek sérülését okozza, vagy</li>
				<li>másod- vagy harmadfokú égési sérüléseket, vagy a testfelület több mint 5%-át érintő égési sérülést okoz;</li>
			</ul>
		</li>
		<li><b>könnyű sérülés:</b> olyan sérülés, amelynek következtében a sérült kórházi kezelésre nem szorul, kivéve a 24 órás megfigyelést.</li>
	</ol>
</li>
<li>Baleset következtében meghalt, megsérült személyek:
<ol type="a">
		<li><b>meghalt személy</b>, aki a baleset következtében a baleset helyszínén, illetve 30 napon belül elhunyt;</li>
		<li><b>súlyosan megsérült személy</b>, aki a baleset következtében súlyos sérülést szenved el;</li>
		<li><b>könnyen megsérült személy</b>, aki baleset következtében könnyű sérülést szenved el.</li>
	</ol>


</li>
</ol>
<p><b>Ittasan okozott baleseteknél</b> a balesetet okozó személy szervezetében a szeszes ital fogyasztásából származó alkohol jelenlétét, illetve annak mértékét véralkohol-vizsgálattal vagy hiteles légalkoholmérővel állapítják meg.</p>
<p><b>Jogi háttér:</b> a 2016. évi CLV. törvény a statisztikáról és a 1992. évi LXIII. törvény a személyes adatok védelméről és a közérdekű adatok nyilvánosságra hozásáról, valamint az Európai Unió 93/704/EK határozata.</p>
<p><b>Az adatok forrása:</b> Az adatfelvétel teljes körű azokra a balesetekre, amikor rendőri intézkedés történik. Az intézkedés során a személysérüléssel járó balesetről adatfelvételi lapot töltenek ki. A baleseti helyszínelő rendőri szerv a kitöltött adatlapot a baleset helye szerinti megyei RFK közlekedésrendészeti osztályának (Budapesten a BRFK Közlekedésrendészeti Főosztályának) küldi meg, ahol az adatlapokat rögzítik. A KSH felé a balesetek adatszolgáltatója az ORFK.</p>
			</div>
		},

		

	eng: {
		title: "Road accidents involving personal injury 2015-2018",

		resetMap: 'Map reset',

		severity: {
			2: 'Fatal',
			4: 'Serious',
			8: 'Minor'
		},

		filtersGroupNames: {
			years: "Years",
			layer: 'Layers',
			outcome: 'Personal injury outcome',
			alcoholFilterTitle: 'Alcohol',
			vehicle: 'causing'
		},

		alcohol: {
			2: '1',
			4: '2',
			8: '3',
			16: '4',
			32: '5'
		},

		layers: {
			hungary: 'Hungary',
			points: 'dots',
			stick: 'stick (heatmap)',
			map: 'map',
			sticksHeight: 'height'
		},

		searchbox: {
			settlement: 'Road number',
			searchButtonText: 'search',
			allButtonText: 'All'
		},

		vehicleToolTip: {
			0: 'motorcycle',
			1: 'car',
			2: 'bus',
			3: 'truck',
			4: 'bicycle',
			5: 'scooter',
			6: 'walker',
			7: 'other'
		},

		toolTip: {
			0: 'Date',
			1: 'Road number',
			2: 'settlement',
			3: 'Outcome',
			4: 'causing'
		},

		methodology: 'methodology',

		accident: 'accident',

		info: 
		<div>
			<h2>Angol verzió még nincs meg!</h2>
		</div>
	}

}